export default __webpack_public_path__ + "static/media/payCode.901c6a82.svg";